module.exports = __webpack_public_path__ + "img/off.41048483.svg";